<template>
  <div v-if="asyncDataStatus_ready" class="col-full push-top">
    <v-row justify="space-between">
      <h2 style="margin-left: 1rem;">
        Uredite nivo cen:
      </h2>
    </v-row>

    <v-col>
      <MyCompanyBusinessUnitPricingForm
        :dates="localPricing.times"
        :name="localPricing.name"
        :description="localPricing.description"
        :isActive="localPricing.is_active"
        skrij
        @save="save"
        @cancel="cancel"
        @setPricingRequest="setPricingAsMainMethod"
        ref="editForm"
      />
    </v-col>

    <v-row>
      <v-col cols="4">
        <v-select
          v-model="selectedCategoryIds"
          :items="categories"
          :menu-props="{ maxHeight: '400' }"
          label="Skupine"
          multiple
          hint="Izberite željene skupine ali pustite prazno za vse skupine"
          persistent-hint
          item-text="name"
          item-value="id"
          clearable
        ></v-select>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-simple-table
          fixed-header
        >
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  Artikel
                </th>
                <th class="text-left">
                  Skupina
                </th>
                <th class="text-left">
                  ME
                </th>
                <th class="text-left">
                  Prodajna Cena
                </th>
                <th class="text-left">
                  Cena na nivoju
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody v-if="loaded">
              <MyCompanyBusinessUnitPricingArticleRow
                v-for="(article, index) in machinearticles"
                :ref="`inventoryformarticlerow-${index}`"
                :key="index"
                :article="article"
                :newKez="index"
                :isNewArticle="newEntry"
                @updateBlur="updateArtileInLocalArrayOnBlue(index, $event)"
                @setCurrent="setCurrent"
                @delete="deleteArticle(index)"
                @gotonext="gotonext(index)"
                @update="updateArticleRowInLocalArray(index, $event)"
              />
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="7">
                  <AppSpinner />
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-row>
      <v-btn
        color="#0F998E"
        class="white--text ml-3"
        :disabled="false"
        @click="undoChanges"
      >
        Prekliči
      </v-btn>
      <v-btn
        color="#0F998E"
        class="white--text ml-3"
        @click="doSavePricingArticles"
      >
        Shrani
      </v-btn>
    </v-row>
    <v-row>
      <v-col class="mt-12"></v-col>
    </v-row>
    <div ref="bottomOfThePage" style="height: 50px;"></div>
    <ConfirmDialog
      ref="confirmdialogunsaved"
      title="Opozorilo"
      text="Ali želiš izhod brez shranjevanja podatkov?"
      okBtnText="Razumem"
      :normal="false"
      v-model="showWarningModal"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import CurrentStockSearchForm from '@/components/CurrentStockSearchForm'
import MyCompanyBusinessUnitPricingForm from "@/components/MyCompanyBusinessUnitPricingForm"
import MyCompanyBusinessUnitPricingArticleRow from '@/components/MyCompanyBusinessUnitPricingArticleRow'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import ConfirmDialog from '@/components/ConfirmDialog'

export default {
  components: {
    CurrentStockSearchForm,
    MyCompanyBusinessUnitPricingForm,
    MyCompanyBusinessUnitPricingArticleRow,
    ConfirmDialog
  },
  mixins: [
    asyncDataStatus
  ],
  props: {
    id: {
      required: true,
      type: Number
    },
    newEntry: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      localArticles: [],
      localCurrentStock: [],
      localEndDate: null,
      localPricing: null,
      unsavedChanges: false,
      showWarningModal: false,
      currentArticle: null,
      is_active: false,
      loaded: false,
      selectedCategoryIds: [],
    }
  },
  computed: {
    machinearticles () {
      var articles = Object.values(this.articles)
      if (this.selectedCategoryIds.length) {
        articles = articles.filter(art => this.selectedCategoryIds.some(id => id === art.category))
      }
      articles = articles.sort((a, b) => {
        return a.category_name.toLowerCase().localeCompare(b.category_name.toLowerCase()) || a.name.toLowerCase().localeCompare(b.name.toLowerCase())
          /* if (a.category_name && b.category_name) {
            if (a.category_name.toLowerCase() > b.category_name.toLowerCase()) {
              return -1
            } else if (a.category_name.toLowerCase() < b.category_name.toLowerCase()) {
              return 1
            }

            /* if (a.name.toLowerCase() < b.name.toLowerCase()) {
              return -1
            } else if (a.name.toLowerCase() > b.name.toLowerCase()) {
              return 1
            } else { // nothing to split them
              return 0
            }
          } */
      }).map((art, _) => ({ ...art, sort: _, new_price: this.localArticles.find(locArt => locArt.article === art.id) ? this.localArticles.find(locArt => locArt.article === art.id).new_price : null,  }))
      return articles
    },
    articles () {
      return this.$store.state.articles.items
    },
    categories () {
      return Object.values(this.$store.state.categories.items)
    }
  },
  methods: {
    ...mapActions('businessUnits', ['loadBusinessUnitPricing', 'setBusinessUnitPricingTime', 'setBusinessUnitPricingArticles', 'setPricingAsMain']),
    ...mapActions('articles', {loadArticles: 'loadItems'}),
    ...mapActions('categories', { loadCategories: 'loadItems' }),
    setPricingAsMainMethod () {
      this.setPricingAsMain(this.id)
        .then(() => {
          this.$notify({
            type: 'success',
            text: 'CENE NIVOJA USPEŠNO UVELJAVLJENE KOT PRODAJNE!'
          })
        })
    },
    setUnsavedChanges () {
      this.unsavedChanges = true
    },
    changedate (date) {
      this.localEndDate = date
    },
    handleFocusOut () {
      this.showWarningModal = true
    },
    printInventoryForm () {
      let routeData = this.$router.resolve({ name: 'MyCompanyInventoryFormPreview', params: { id: this.id } })
      window.open(routeData.href, '_blank')
    },
    save ({ data }) {
      if (!this.unsavedChanges) return
      // this.saveItem({ ...data })
      // this.$router.replace({ name: 'MyCompanyInventoryForms' })
      this.doSavePricingArticles()
    },
    formatDates (dates) {
      return dates.map(dateInfo => {
        const [start_hour, start_minute, __] = dateInfo.startTime.split(':').map(every => Number(every))
        const [end_hour, end_minute, ____] = dateInfo.endTime.split(':').map(every => Number(every))
        if (dateInfo.type === 'day') {
          return {
            start_month: null,
            end_month: null,
            start_day: dateInfo.days.val,
            end_day: dateInfo.days.val,
            start_hour,
            start_minute,
            end_hour,
            end_minute
          }
        } else {
          const [_, start_month, start_day] = dateInfo.startDate !== null && dateInfo.startDate.split('-').map(every => Number(every))
          const [___, end_month, end_day] = dateInfo.endDate !== null && dateInfo.endDate.split('-').map(every => Number(every))
          return {
            // ...dateInfo,
            start_month,
            start_day,
            end_month,
            end_day,
            start_hour,
            start_minute,
            end_hour,
            end_minute
          }
        }
      })
    },
    cancel () {
      this.$router.push({ name: 'MyCompanyInventoryForms' })
    },
    doSavePricingArticles () {
      // { id: null, times: this.formatDates(form.data.dates), name: form.data.name, is_active: form.data.is_active, decription: form.data.description }
      // console.log(JSON.stringify(this.localArticles))
      this.setBusinessUnitPricingArticles({
        pricingId: this.id,
        items: {
          articles: this.localArticles.filter(art => art.new_price).map(art => ({ article: art.article, price: art.new_price }))
        }
      })
        .then(response => {
          this.unsavedChanges = false
          const editedFormData = this.$refs.editForm.returnFormData()
          this.setBusinessUnitPricingTime({ ...editedFormData, id: this.id, times: this.formatDates(editedFormData.dates) })
          this.$router.replace({ name: 'MyCompanyBusinessUnitPricing' })
        })
    },
    setCurrent (toSet) {
      this.currentArticle = toSet
    },
    updateArtileInLocalArrayOnBlue (index, article) {
      // console.log(this.localArticles, article, index)
      // try to find article in list (already exists)
      index = this.localArticles.findIndex(lA => lA.article === article.article)
      if (index === -1) {
        this.localArticles.push(article)
      } else {
        this.localArticles[index] = article
      }
      if (!article.new_price) {
        // remove article from localArticles
        this.localArticles.splice(index, 1)
      }
      this.unsavedChanges = true
    },
    updateArticleRowInLocalArray (index, article) {
      console.log(this.localArticles, article, index)
      // try to find article in list (already exists)
      index = this.localArticles.findIndex(lA => lA.article === article.article)
      if (index === -1) {
        this.localArticles.push(article)
      } else {
        this.localArticles[index] = article
      }
      if (!article.new_price) {
        // remove article from localArticles
        this.localArticles.splice(index, 1)
      }
      const indexSeq = this.currentArticle + 1
      this.unsavedChanges = true
      const geenrated = `inventoryformarticlerow-${indexSeq}`

      this.$refs[geenrated][0].$refs.new_price.focus()
    },
    gotonext() {
      const indexSeq = this.currentArticle + 1
      const geenrated = `inventoryformarticlerow-${indexSeq}`
      this.$refs[geenrated][0].$refs.new_price.focus()
    },
    deleteArticle (index) {
      this.localArticles.splice(index, 1)
      const newArray = this.localArticles
      this.localArticles = []
      this.$nextTick(() => {
        this.localArticles = newArray
      })
      this.unsavedChanges = true
    },
    undoChanges () {
      this.$router.push({ name: 'MyCompanyBusinessUnitPricing' })
    }
  },
  created () {
    this.loaded = false
    Promise.all([
      this.loadBusinessUnitPricing(this.id),
      this.loadArticles(),
      this.loadCategories()
    ])
      .then(response => {
        this.localPricing = response[0][0]
        this.localArticles = response[0][0].articles.map(art => ({ article: art.id, new_price: art.price }))
        this.is_active = response[0][0].is_active
        this.asyncDataStatus_fetched()
        this.loaded = true
      })
  },
  watch: {
  },
  async beforeRouteLeave (to, from, next) {
    if (to.name === 'MyCompanyBusinessUnitPricing') {
      next()
    } else {
      this.showWarningModal = true
      next(await this.$refs.confirmdialogunsaved.pop())
    }
  }
}
</script>
